import { Logger } from '@utils/logger/logger';
import Joi from 'joi';

export interface Query {
	size?: number;
	page?: number;
}

const querySchema = Joi.object<Required<Query>>({
	size: Joi.number().integer().min(1).max(50).default(20),
	page: Joi.number().integer().min(1).default(1),
});

export const buildVariablesForReviewForGallery = async (
	storefrontId: string,
	query: Query,
) => {
	try {
		const { size, page } = await querySchema.validateAsync(query);

		return {
			id: storefrontId,
			size,
			page,
		};
	} catch (e) {
		Logger.error({
			errorToLog: e,
			newRelic: true,
			log_message: 'Error in buildVariables function for getReviewsForGallery',
		});
		throw e;
	}
};
